import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=47bba4f0&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=47bba4f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bba4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bba4f0')) {
      api.createRecord('47bba4f0', component.options)
    } else {
      api.reload('47bba4f0', component.options)
    }
    module.hot.accept("./FeatureCard.vue?vue&type=template&id=47bba4f0&scoped=true", function () {
      api.rerender('47bba4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/FeatureCard.vue"
export default component.exports